import { Box, styled } from "@mui/material";

export const StepStyled = styled(Box)<{ steps: number }>`
	position: relative;
	width: ${(props) =>
		(props.steps === 7 && "14%") ||
		(props.steps === 6 && "16.5%") ||
		(props.steps <= 5 && "20.1%") ||
		"20.1%"};
	height: 25em;

	&.mega-menu-variant {
		height: 20em;
	}
	&.first-step {
		width: 8.6%;
	}
	&.portrait {
		width: 12em;

		/* .claim-button {
			transform: rotate(90deg) translateX(2px);
		} */
		.reward-item {
			transform: rotate(90deg) translateX(8em);
		}
		.target {
			transform: rotate(90deg) translate(-8.985em, 0);
			z-index: -1;
		}
		.step-marker {
			transform: rotate(90deg) translateX(-10em);
			background-color: unset;
			border: unset;
			box-shadow: unset;
		}
		.progress-reward-step {
			transform: translateY(-8.5em);
		}
		.loyalty-points-indicator {
			transform: rotate(90deg) translate(-2em, 1em);
		}
		.progress-indicator.marker {
			transform: rotate(-90deg) translate(-1.145em, 0);
			z-index: -1;
		}
		.container-indicator {
			&::before {
				height: 6.2em;
			}
		}
	}
`;

export const Reward = styled(Box)`
	position: absolute;
	z-index: 10;
	bottom: 0;
	right: 0;
	gap: 1.6em;
	transform: translateX(2.4em);
	width: 4em;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
`;

export const ProgressRewardStep = styled(Box)`
	background-color: rgba(0, 0, 0, 0.51);
	border-top: 0.22em solid #fff;
	border-bottom: 0.22em solid #fff;
	position: absolute;
	top: 50%;
	transform: translateY(1.5em);
	left: 0;
	width: 100%;
	height: 1.8em;
	padding: 0.176em;

	&.first {
		border-left: 0.22em solid #fff;
		border-radius: 1.76em 0 0 1.76em;
	}
	&.last-step {
		width: 50%;
	}
	&.mega-menu-variant {
		transform: translateY(0.975vw);
	}
`;

export const Bar = styled(Box)`
	position: relative;
	width: 100%;
	height: 100%;
	border-radius: 1.76em;
	background-color: transparent;
`;

export const Percentage = styled(Box)`
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	display: flex;
	justify-content: flex-end;
	background: linear-gradient(
		180deg,
		#ffe37e 0%,
		#ffe178 19.09%,
		#ffda58 20.5%,
		#ffc700 100%
	);

	&.first {
		border-radius: 1.76em 0 0 1.76em;
	}
`;

export const RewardItem = styled(Box)`
	width: 5.2em;
	height: 5.2em;

	&.page-variant {
		width: 7em;
		height: 7em;
		transform: translateY(-1.2316em);
	}
	//&.mega-menu-variant {}
	padding: 0.4em;
	border-radius: 1.21em;
	background-color: #fff;
	&.in-progress {
		background-color: #ffca0d;
	}
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	z-index: 1;
`;

export const RewardText = styled(Box)`
	font-size: 1.8em;
	font-family: "Baloo";
	position: absolute;
	bottom: -0.15em;
	right: 0.2em;
	color: white;
	paint-order: stroke fill;
	-webkit-text-stroke-width: 0.165em;
	-webkit-text-stroke-color: #000;
	filter: drop-shadow(0.07em 0.07em 0 #000);
	display: flex;
	align-items: center;

	&.page-variant {
		font-size: 2em;
	}
`;

export const RewardImage = styled(Box)<{ background: string; color?: string }>`
	position: relative;
	width: 100%;
	height: 100%;
	border-radius: 1.21em;
	background-image: url(${(props) => props.background});
	background-color: ${(props) => props.color || "#F8CB53"};
	background-size: cover;
	background-position: center bottom;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const RewardPrizeImage = styled("img")<{ status: string }>`
	width: auto;
	height: auto;
	width: 80%;
	height: 75%;
	object-fit: contain;
	filter: ${(props) =>
		props.status === "unlocked" ? "grayscale(1.0)" : "none"};
`;
